import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { BusinessHourRequest, DeleteCompanyBusinessHourRequest } from "@/main/models/request/businessHourRequest";
import { BusinessHourResponse } from "@/main/models/response";

export abstract class ICompanyBusinessHourApi {
	abstract saveBusinessHour(request: BusinessHourRequest): Promise<AxiosResponse<Result<BusinessHourResponse>>>;

	abstract deleteBusinessHour(
		request: DeleteCompanyBusinessHourRequest[],
	): Promise<AxiosResponse<Result<BusinessHourResponse>>>;
}
